'use client';
import { useEffect, useRef, useState } from 'react';
import type { Currency } from '@witmetrics/utils';
import { useAllProducts, useDispatch } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { DEFAULT_CURRENCY } from '@/constants/pricing';
import { fetchShopProduct } from './utils';

export function useShopProduct() {
  const hasFetched = useRef(false);
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const products = useAllProducts();
  const [currency, setCurrency] = useState<Currency | null>(null);
  const [isFetching, toggleFetching] = useToggle(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    try {
      toggleFetching(true);
      const result = await fetchShopProduct();
      if (result) {
        dispatch.addProducts([result.product]);
        setCurrency(result.currency);
      }
      toggleFetching(false);
    } catch (err) {
      toggleFetching(false);
      onApiError(err, 'Error fetching the product');
    }
  };

  const product = products[0];

  return {
    product,
    isFetching,
    currency: currency || (DEFAULT_CURRENCY as Currency),
    unitPrice: product ? parseFloat(product.price) : 0,
  };
}
